import { isPresent } from "@grandvisionhq/utils";
const getFaceShapes = (faceShape) => faceShape.map(({ shape }) => shape?.toLocaleLowerCase())?.filter(isPresent);
export {
  getFaceShapes
};
//# sourceMappingURL=get-face-shapes.js.map
